import React, { useCallback } from "react";
import WidgetDrawer from "./WidgetDrawer";
import {
    CrossChannelRatingAndReviewTableWidget,
    TrendsComparisionWidget,
} from "@components/widgets";
import { Col, Row, Select, Radio } from "antd";
import { includes } from "underscore";
import { ICrossChannelRatingAndReviewWidget } from "@ts/common-types";

const CrossChannelRatingAndReviewWidget: React.FC<
    ICrossChannelRatingAndReviewWidget
> = ({
    title,
    show,
    setShow,
    widgetData,
    selectedComparisionChannel,
    comparisionSelectOptions,
    onChannelComparisionChange,
    comparisionSelectDataType,
    setComparisionSelectDataType,
}) => {
    const onClose = () => {
        setShow(false);
    };

    const radioOptions = [
        { label: "Count", value: "count" },
        { label: "Score", value: "score" },
    ];

    const drawerTitle = useCallback(
        (title: string) => {
            return (
                <div className="d-flex justify-content-between align-items-center pe-5">
                    <h5>{title}</h5>
                    <span className="d-flex align-items-center justify-content-end fs-6 gap-2">
                        <label>Compare with: </label>
                        <Select
                            value={
                                selectedComparisionChannel || [
                                    comparisionSelectOptions[0].value,
                                ]
                            }
                            options={comparisionSelectOptions}
                            onChange={onChannelComparisionChange}
                            mode="multiple"
                            maxTagCount={1}
                            allowClear
                            style={{ width: "18ch" }}
                            maxTagTextLength={10}
                            disabled={
                                comparisionSelectOptions?.length === 1 &&
                                includes(selectedComparisionChannel, "all")
                            }
                        />
                        <Radio.Group
                            options={radioOptions}
                            onChange={(e) =>
                                setComparisionSelectDataType(e.target.value)
                            }
                            value={comparisionSelectDataType}
                            optionType="button"
                            buttonStyle="solid"
                        />
                    </span>
                </div>
            );
        },
        [widgetData, comparisionSelectDataType, selectedComparisionChannel]
    );

    return (
        <WidgetDrawer
            title={drawerTitle(title)}
            width="85vw"
            show={show}
            onClose={onClose}
            bodyStyle={{ backgroundColor: "#FFFFFF" }}
        >
            <Row>
                <Col span={12}>
                    <TrendsComparisionWidget
                        title=""
                        isTitleRequired={false}
                        isCardRequired={false}
                        widgetData={
                            widgetData.charts.reviews[comparisionSelectDataType]
                        }
                        graphAttributes={{
                            title:
                                comparisionSelectDataType === "count"
                                    ? "#Ratings"
                                    : "Ratings",
                            yAxisTitle:
                                comparisionSelectDataType === "count"
                                    ? "#Ratings"
                                    : "Ratings",
                        }}
                    />
                </Col>
                <Col span={12}>
                    <TrendsComparisionWidget
                        title=""
                        isTitleRequired={false}
                        isCardRequired={false}
                        widgetData={
                            widgetData.charts.ratings[comparisionSelectDataType]
                        }
                        graphAttributes={{
                            title:
                                comparisionSelectDataType === "count"
                                    ? "#Reviews"
                                    : "Review Ratings",
                            yAxisTitle:
                                comparisionSelectDataType === "count"
                                    ? "#Reviews"
                                    : "Review Ratings",
                        }}
                    />
                </Col>
            </Row>
            <CrossChannelRatingAndReviewTableWidget widgetData={widgetData} />
        </WidgetDrawer>
    );
};

export default CrossChannelRatingAndReviewWidget;
